'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var ZenderEvents = {
	ready: 'zender:ready',
	fail: 'zender:fail', // DEPRECATED: use player:fail in stead
	update: 'zender:update', // DEPRECATED: use media:update or media:init in stead
	player_fail: 'zender:player:fail',
	player_ready: 'zender:player:ready',
	player_close: 'zender:player:close',
	player_log: 'zender:player:log',
	player_lobby_enter: 'zender:player:lobby:enter',
	player_lobby_leave: 'zender:player:lobby:leave',
	ui_trigger_notification: 'zender:ui:trigger:notification',
	ui_panel_expand: 'zender:ui:panel:expand',
	ui_panel_collapse: 'zender:ui:panel:collapse',
	ui_panel_collapse_all: 'zender:ui:panel:collapseall',
	ui_button_show: 'zender:ui:button:show',
	ui_button_hide: 'zender:ui:button:hide',
	ui_streams_overview: 'zender:ui:streams:overview',
	auth_authenticate: 'zender:authentication:authenticate',
	auth_required: 'zender:authentication:required',
	auth_logout: 'zender:authentication:logout',
	auth_success: 'zender:authentication:success',
	auth_fail: 'zender:authentication:fail',
	auth_init: 'zender:authentication:init',
	deep_link: 'zender:deeplink:open',
	open_url: 'zender:open:url',
	share: 'zender:share',
	app_active: 'zender:app:activate',
	app_deactive: 'zender:app:deactivate',
	keyboard_will_show: 'zender:keyboard:willshow',
	keyboard_did_show: 'zender:keyboard:didshow',
	keyboard_will_hide: 'zender:keyboard:willhide',
	keyboard_did_hide: 'zender:keyboard:didhide',
	device_settoken: 'zender:device:settoken',
	device_register: 'zender:device:register',
	device_unregister: 'zender:device:unregister',
	device_subscribe: 'zender:device:subscribe',
	device_unsubscribe: 'zender:device:unsubscribe',
	targets_init: 'zender:targets:init',
	channels_streams_init: 'zender:channels:streams:init',
	channels_streams_publish: 'zender:channels:streams:publish',
	channels_streams_unpublish: 'zender:channels:streams:unpublish',
	streams_init: 'zender:streams:init',
	streams_update: 'zender:streams:update',
	streams_unpublish: 'zender:streams:unpublish',
	streams_stats: 'zender:streams:stats',
	media_init: 'zender:media:init',
	media_update: 'zender:media:update',
	media_delete: 'zender:media:delete',
	media_play: 'zender:media:play',
	media_video_quality: 'zender:media:video:quality',
	media_unsupported: 'zender:media:unsupported',
	emojis_init: 'zender:emojis:init',
	emojis_update: 'zender:emojis:update',
	emojis_stats: 'zender:emojis:stats',
	avatars_stats: 'zender:avatars:stats',
	emojis_trigger: 'zender:emojis:trigger',
	avatars_trigger: 'zender:avatars:trigger',
	shoutbox_init: 'zender:shoutbox:init',
	shoutbox_update: 'zender:shoutbox:update',
	shoutbox_shouts: 'zender:shoutbox:shouts',
	shoutbox_shouts_delete: 'zender:shoutbox:shouts:delete',
	shoutbox_replies: 'zender:shoutbox:replies',
	shoutbox_shout: 'zender:shoutbox:shout',
	shoutbox_shout_send: 'zender:shoutbox:shout:sent',
	polls_init: 'zender:polls:init',
	polls_update: 'zender:polls:update',
	polls_results: 'zender:polls:results',
	polls_results_animate: 'zender:polls:results:animate',
	polls_reset: 'zender:polls:reset',
	polls_delete: 'zender:polls:delete',
	polls_vote: 'zender:polls:vote',
	quiz_init: 'zender:quiz:init',
	quiz_start: 'zender:quiz:start',
	quiz_stop: 'zender:quiz:stop',
	quiz_question: 'zender:quiz:question',
	quiz_question_results: 'zender:quiz:question:results',
	quiz_answer_correct: 'zender:quiz:answer:correct',
	quiz_answer_incorrect: 'zender:quiz:answer:incorrect',
	quiz_extralife_use: 'zender:quiz:extralife:use',
	quiz_extralife_ignore: 'zender:quiz:extralife:ignore',
	quiz_answer_submit: 'zender:quiz:answer:submit',
	quiz_answer_timeout: 'zender:quiz:answer:timeout',
	quiz_eliminated: 'zender:quiz:eliminated',
	quiz_eliminated_continue: 'zender:quiz:eliminated:continue',
	quiz_results: 'zender:quiz:results',
	quiz_winner: 'zender:quiz:winner',
	quiz_loser: 'zender:quiz:loser',
	quiz_reset: 'zender:quiz:reset',
	quiz_delete: 'zender:quiz:delete',
	quiz_answer: 'zender:quiz:answer',
	quiz_question_redeem: 'zender:quiz:question:redeem',
	quiz_share_code: 'zender:quiz:share:code',
	quiz_setcode: 'zender:quiz:setcode',
	team_init: 'zender:team:init',
	team_share_code: 'zender:team:share:code',
	team_setcode: 'zender:team:setcode'
};

exports.default = ZenderEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/zender-js/dist/events.js
// module id = 564
// module chunks = 0